import "whatwg-fetch";
import { LANGS, Codes } from "./langs";

// point the URL to localhost if running docker container from local machine
//const REST_URL = "http://localhost:8080"; //local machine
//const REST_URL = "https://dev.techlearningzone.com"; //dev server
const REST_URL = "https://runtime.techlearningzone.com"; //prod server
//const REST_URL = process.env.NODE_ENV === 'production' ? "http://18.138.160.130:8080" : "http://localhost:8080";

const getToken = () => {
  const tkn = localStorage.getItem("tkn");
  return tkn;
};

// Golang API
export async function Compile(code, lang) {
  //1st arg is either "Python", "Plain JavaScript", "Go", "Bash" or "Perl"
  //2nd zero is always fixed as 0 - let langid = LANGS[i][0]
  //   let langid = LANGS["JavaScript"][0]
  let langid = LANGS[lang][0];
  //   let codeF = Codes["JavaScript"]
  //langName[langid] = i

  const langLower = lang.toLowerCase();
  //console.log("compileSvc -> langLower: ", langLower);
  const b64Code = btoa(code);
  //console.log("compileSvc -> : b64Code", b64Code);
  //prepare data
  let data = {
    language: langLower,
    //code: code
    code: b64Code
  };

  try {
    const response = await fetch(`${REST_URL}/compile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getToken()
      },
      body: JSON.stringify(data)
    });
    const json = await response.json();
    //console.log("result: ", JSON.stringify(json));
    return json;
  } catch (error) {
    console.log("Compile API error: " + JSON.stringify(error));
    return error;
  }
}
